import { startTransition, StrictMode } from 'react'
import { hydrateRoot } from 'react-dom/client'
import { HydratedRouter } from 'react-router/dom'

import './lib/sentry.js'

if (window.location.pathname === '/auth/bridge') {
  void import('./lib/auth/bridge-page.js').then(({ initAuthBridgePage }) => {
    initAuthBridgePage()
  })
}

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <HydratedRouter />
    </StrictMode>,
  )
})
